import { ERRORE_ASR, ERRORE_BLOCKING, ERRORE_DATI_ERRATI, ERRORE_PAZIENTE_NON_TROVATO, ERRORE_SESSION_EXPIRED, ERRORE_UNAUTHORIZED } from "../../global/messaggioLabels";
import { IDLE } from "../../global/statusLabels";
import { RESET_MESSAGGIO, RESET_SNACKBAR, SET_MESSAGGIO, SET_SNACKBAR } from "./actionsType";

export const initialState = {
    messaggio: { value: undefined, status: IDLE, timeout: IDLE },
    snackbar: undefined
}

export const messaggioReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MESSAGGIO:
            if (state.messaggio?.status !== ERRORE_ASR && state.messaggio?.status !== ERRORE_UNAUTHORIZED && state.messaggio?.status !== ERRORE_BLOCKING && state.messaggio?.status !== ERRORE_SESSION_EXPIRED && state.messaggio?.status !== ERRORE_PAZIENTE_NON_TROVATO && state.messaggio?.status !== ERRORE_DATI_ERRATI) {
                return {
                    ...state,
                    messaggio: action.payload
                }
            }
            else
                return state
        case RESET_MESSAGGIO:
            return {
                ...state,
                messaggio: { value: undefined, status: IDLE, timeout: IDLE }
            };
        case SET_SNACKBAR:
            return {
                ...state,
                snackbar: action.payload
            }
        case RESET_SNACKBAR:
            return {
                ...state,
                snackbar: undefined
            };
        default:
            return state;
    }
}